<ul #list tabindex="-1" data-cy="searchbar-tag-list">
  <suggestion-tag
    [@fadeIn]="'in'"
    *ngFor="let tag of model; trackBy: trackTags; index as i"
    [model]="tag"
    #tag
    tabindex="0"
    [pTooltip]="tag?.tooltip ?? ((tag.label ? tag.label + ': ' : '') + tag.title | capitalize)"
    tooltipPosition="bottom"
    tooltipStyleClass="u-tooltip"
    [class.minimized]="minimizeTags"
    (remove)="onRemove(tag)"
    (focus)="onTagFocus(i)"
    [removable]="removable"
  ></suggestion-tag>
</ul>

<ul tabindex="-1" style="visibility: hidden; position: absolute" #tagWidth>
  <suggestion-tag
    *ngFor="let tag of model; trackBy: trackTags"
    [model]="tag"
    #transparentTag
    tabindex="0"
    (remove)="onRemove(tag)"
  ></suggestion-tag>
</ul>
